import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgSmileIconSecondary from './svgs/SmileIconSecondary.js';
import SvgSmileIcon from './svgs/SmileIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var smileIcon = (props => useIcon(SvgSmileIcon, SvgSmileIconSecondary, props));

export { smileIcon as default };
